import { createSlice } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";
import { VideoLessonItem } from "../../../Pages/UserVideoLessonDetail/ILessonsList";

// 👇 Combine the interfaces to represent a full video Topic item
export type IVideoTopic = any;

export const FavAndWatchLaterVideoLessonsSlice = createSlice({
  name: "FavAndWatchLaterVideoLessonsSlice",
  initialState: {} as IReduxState<IVideoTopic>,
  reducers: {
    FavAndWatchLaterVideoLesson: (state, action) => {
      state.isLoading = false;
    },

    successFavAndWatchLaterVideoLessons: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failureFavAndWatchLaterVideoLessons: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
  },
});

export const {
  FavAndWatchLaterVideoLesson,
  successFavAndWatchLaterVideoLessons,
  failureFavAndWatchLaterVideoLessons,
} = FavAndWatchLaterVideoLessonsSlice.actions;

export default FavAndWatchLaterVideoLessonsSlice.reducer;
